import { render, staticRenderFns } from "./monthlyColors.vue?vue&type=template&id=9bcc3bae&scoped=true"
import script from "./monthlyColors.vue?vue&type=script&lang=js"
export * from "./monthlyColors.vue?vue&type=script&lang=js"
import style0 from "./monthlyColors.vue?vue&type=style&index=0&id=9bcc3bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcc3bae",
  null
  
)

export default component.exports